import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  DATA_EXPORT,
  ERROR_MESSAGE,
} from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { Box } from "@mui/material";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const SalesbyCustomerTypeDetail = (props) => {
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    currencySymbolLocation,
    ReportViewPermission,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(location)
  );

  const [selectedMethod, setSelectedMethod] = useState(1);

  const Methods = [
    { label: "Accrual", value: 1 },
    { label: "Cash", value: 2 },
  ];

  const handleMethodDropdownChange = (selectedOption) => {
    setSelectedMethod(selectedOption.value);
  };

  const [classicView, setClassicView] = useState(true);

  const [nemultiselect, setnemultiselect] = useState({
    TransactionType: [],
    CustomerTypeName: [],
  });

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const renderAccordionIcon = (index) => {
    if (activeAccordion === index) {
      return <FontAwesomeIcon icon={faChevronUp} />;
    } else {
      return <FontAwesomeIcon icon={faChevronDown} />;
    }
  };
  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/salesbydetails?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&iscusttypereport=${1}&locationid=${selectedlocationid}&customerid=0&itemid=0&currentlocationid=${location}&method=${selectedMethod}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData.length > 0) {
            const FilterData = res.data.ResponseData?.map((el) => ({
              ...el,
              Quantity: Number(el?.Quantity),
              Rate: Number(el?.Rate),
              Amountline: Number(el?.Amountline),
              SKU: String(el?.SKU),
            }));
            const data = res.data.ResponseData;
            setnemultiselect({
              TransactionType: [
                ...new Set(data?.map((item) => item?.TransactionType)),
              ],
              TransactionType: [
                ...new Set(data?.map((item) => item?.TransactionType)),
              ],
              CustomerTypeName: [
                ...new Set(data?.map((item) => item?.CustomerTypeName)),
              ],
            });

            setResponseData(FilterData);
            setLoading(false);
          } else {
            toastWarn("No Records Found!");
            setLoading(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "DATE",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) =>
        moment(row.original.DATE).format("YYYY-MM-DD") === "Invalid date"
          ? ""
          : moment(row.original.DATE).format(`${dateFormate.toUpperCase()}`),
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      size: "120",
      filterSelectOptions: nemultiselect?.TransactionType, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
      Cell: ({ row }) => {
        return (
          <p title={`Retun/Memo / Payment(Credit Applied)`}>
            {row.original.TransactionType}
          </p>
        );
      },
    },
    {
      header: "Num",
      accessorKey: "TransactionNumber",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => (
        <Link
          style={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "600",
            p: "0.3rem",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          type="button"
          onClick={() =>
            window.open(
              `/sales-receipt/${row?.original?.TransactionNumber}`,
              "_blank"
            )
          }
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          {row?.original?.TransactionNumber}
        </Link>
      ),
    },
    {
      header: "Product/Service",
      accessorKey: "ItemName",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Description",
      accessorKey: "Description",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Qty",
      accessorKey: "Quantity",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => {
        const Quantity = parseFloat(row?.original?.Quantity);

        if (isNaN(Quantity) || Quantity === 0) {
          return <div style={{ textAlign: "end" }}></div>;
        } else {
          return (
            <div style={{ textAlign: "end" }}>{`${Quantity.toFixed(2)}`}</div>
          );
        }
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number"
            ? aggregatedValue.toLocaleString("en-US", {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "N/A"; // Fallback for non-numeric values

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        );
      },
    },
    {
      header: "Sale Price",
      accessorKey: "Rate",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => {
        const rate = row?.original?.Rate;
        if (rate == "0.00" || rate == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(rate),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Amount",
      accessorKey: "Amountline",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => {
        const amount = row?.original?.Amountline;
        if (amount == "0.00" || amount == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(amount),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number"
            ? CurrencySymbols(
                Number(aggregatedValue),
                { CurrencySymbol },
                FractionDigits
              )
            : "N/A";

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {formattedValue}
            </Box>
          </>
        );
      },
    },
    {
      header: "Balance",
      accessorKey: "Balance",
      filterFn: "contains",
      size: "110",
      enableSorting: false,
      Cell: ({ row }) => {
        const balance = row?.original?.Balance;
        if (balance == "0.00" || balance == "") {
          return "";
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(balance),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "SKU",
      accessorKey: "SKU",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Last Modified User",
      accessorKey: "ModifiedBy",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Last Modified Date",
      accessorKey: "LastModified",
      filterFn: "contains",
      Cell: ({ row }) => {
        const transactionDate = moment(row.original.LastModified);
        if (transactionDate.isValid()) {
          return moment(transactionDate).format(
            `${dateFormate.toUpperCase()} h:mm A`
          );
        } else {
          return "";
        }
      },
    },
    {
      header: "A/R Paid",
      accessorKey: "Status",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Account",
      accessorKey: "Account",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Created Date",
      accessorKey: "CreateDate",
      filterFn: "contains",
      size: "140",
      Cell: ({ row }) =>
        moment(row.original.CreateDate).format(
          `${dateFormate.toUpperCase()} h:mm A`
        ),
    },
    {
      header: "Created User",
      accessorKey: "CreatedBy",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Customer Name",
      accessorKey: "CustomerName",
      filterFn: "contains",
      size: "110",
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Sale Id",
      accessorKey: "SaleId",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "SaleItem ID",
      accessorKey: "SaleItemID",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Customer Type ",
      accessorKey: "CustomerTypeName",
      size: "110",
      filterSelectOptions: nemultiselect?.CustomerTypeName, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
      // filterFn: "contains",
    },
    {
      header: "Customer Role Type ",
      accessorKey: "RoleTierID",
      filterFn: "contains",
      size: "110",
    },

    {
      header: "Customer / Vendor Message ",
      accessorKey: "CustVendorMessage",
      filterFn: "contains",
      size: "110",
    },
  ]);

  const Classiccolumns = [
    {
      title: "Date",
      field: "DATE",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Transaction Type",
      field: "TransactionType",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const data = cell.getRow().getData();
        const span = document.createElement("span");

        span.textContent = data.TransactionType || "";
        // span.style.borderRadius = "0.3rem";
        // span.style.color = "#343f62";
        // span.style.maxWidth = "18ch";
        // span.style.textDecoration = "underline";
        // span.style.textUnderlineOffset = "3px";
        // span.style.padding = "0.3rem";
        // span.style.cursor = "pointer";
        // span.style.display = "flex";
        // span.style.alignItems = "center";
        // span.style.overflow = "hidden";
        // span.style.whiteSpace = "nowrap";
        // span.style.textOverflow = "ellipsis";
        // span.style.fontWeight = "900";

        // span.addEventListener("click", (e) => {
        //   e.preventDefault();
        //   const TransactionNumber = data.TransactionNumber;
        //   let url = `/sales-receipt/${TransactionNumber}`; // default
        //   window.open(url, "_blank");
        // });

        return span;
      },
    },
    {
      title: "Num",
      field: "TransactionNumber",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const data = cell.getRow().getData();
        const span = document.createElement("span");

        span.textContent = data.TransactionNumber || "";
        span.style.borderRadius = "0.3rem";
        span.style.color = "#343f62";
        span.style.maxWidth = "18ch";
        span.style.textDecoration = "underline";
        span.style.textUnderlineOffset = "3px";
        span.style.padding = "0.3rem";
        span.style.cursor = "pointer";
        span.style.display = "flex";
        span.style.alignItems = "center";
        span.style.overflow = "hidden";
        span.style.whiteSpace = "nowrap";
        span.style.textOverflow = "ellipsis";
        span.style.fontWeight = "900";

        span.addEventListener("click", (e) => {
          e.preventDefault();
          const TransactionNumber = data.TransactionNumber;
          let url = `/sales-receipt/${TransactionNumber}`; // default
          window.open(url, "_blank");
        });

        return span;
      },
    },
    {
      title: "Product/Service",
      field: "ItemName",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },

    {
      title: "Description",
      field: "Description",
      headerFilter: "input",
      defaultVisible: true,
      // frozen: true,
    },
    {
      title: "Quantity",
      field: "Quantity",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      // frozen: true,
    },
    {
      title: "Sales Price",
      field: "Rate",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Amount",
      field: "Amountline",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Balance",
      field: "Balance",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "SKU",
      field: "SKU",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Last Modified Date",
      field: "LastModified",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Last Modified User",
      field: "ModifiedBy",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Account",
      field: "Account",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "A/R Paid",
      field: "Status",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Create Date",
      field: "CreateDate",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Created By",
      field: "CreatedBy",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Customer Name",
      field: "CustomerName",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Sale Id",
      field: "SaleId",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Customer Type Name",
      field: "CustomerTypeName",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Customer Role Type",
      field: "RoleTierID",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Customer / Vendor Message",
      field: "CustVendorMessage",
      headerFilter: "input",
      defaultVisible: true,
    },
  ];

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Sales By Customer Type Detail
                </li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find(
                      (el) => el?.value === selectReport
                    )}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                <div className="row">
                  <ReportDate
                    callback={callback}
                    selectReport={selectReport}
                    showhidecomponent={
                      selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Accounting method
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={Methods}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  name="method"
                  id="method"
                  value={Methods.find((e) => e.value === selectedMethod)}
                  onChange={handleMethodDropdownChange}
                  className="custom-search-select"
                />
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 class="p">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      Sales By Customer Type Detail
                    </p>
                    <div className="row mb-0">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  {ReportViewPermission == true ? (
                    <button
                      className="btn btn-secondary"
                      onClick={() => setClassicView(!classicView)}
                    >
                      {" "}
                      {classicView ? "ClassicView" : "Morden View"}
                    </button>
                  ) : (
                    <></>
                  )}
                  {classicView ? (
                    <CommonTabular
                      Data={responseData}
                      columns={Classiccolumns}
                      Groupvalue={["CustomerTypeName"]}
                      Reportname={"Sales By Customer Type Detail"}
                      frozenRowvalue={0}
                      layout={"fitDataFill"}
                      Onrefresh={() => apicall()}
                    />
                  ) : (
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Sales By Customer Type Detail"
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      enableExpandAll={true}
                      enableExpanding={true}
                      expanded={true}
                      columnGrouping={["CustomerTypeName"]} // CustomerName
                      columnsVisibility={{}}
                      enableRowSelection={false}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SalesbyCustomerTypeDetail;
